<template>
  <el-card :loading="loading">
    <div style="display:flex;justify-content:space-between;align-items:center" slot="header">
      <div>基本信息</div>
      <el-button type="primary" size="small" @click="addNewModal = true">编辑详情</el-button>
    </div>
    <el-form ref="detailModalForm" class="detailDialog" :label-position="'left'" label-suffix="：" label-width="100px">
      <el-form-item prop="name" :label="$t('supplier::table_name')">
        {{ detailModalForm.name }}
      </el-form-item>
      <el-form-item prop="contacts" :label="$t('supplier::table_staff')">
        {{ detailModalForm.contacts }}
      </el-form-item>
      <el-form-item prop="phone" :label="$t('supplier::table_phone')">
        {{ detailModalForm.phone }}
      </el-form-item>
      <el-form-item prop="area" :label="$t('supplier::form_area')">
        {{ detailModalForm.province }}{{ detailModalForm.city }}{{ detailModalForm.area }}
      </el-form-item>
      <el-form-item prop="address" :label="$t('supplier::form_address')">
        {{ detailModalForm.address }}
      </el-form-item>
      <el-form-item prop="email" :label="$t('supplier::form_email')">
        {{ detailModalForm.email }}
      </el-form-item>
    </el-form>
    <template v-if="addNewModal">
      <editDialog
        :id="id"
        :isNew="false"
        v-model="addNewModal"
        :formData="detailModalForm"
        @getListData="getDetail"
      ></editDialog>
    </template>
  </el-card>
</template>

<script>
import { getSupplierDetail } from '@/server/supplier'
import editDialog from '../components/editDialog'
export default {
  components: {
    editDialog
  },
  data() {
    return {
      id: this.$route.params.id,
      detailModalForm: {
        name: '',
        contacts: '',
        phone: '',
        address: '',
        email: '',
        province: '',
        city: '',
        area: ''
      },
      loading: false,
      addNewModal: false
    }
  },
  mounted() {
    // this.getDetail()
  },
  watch: {
    $route: {
      handler: function(to) {
        if (to.params && to.params.id) {
          this.id = to.params.id
          this.getDetail()
        }
      },
      immediate: true
    }
  },
  methods: {
    async getDetail() {
      this.loading = true
      let data = await getSupplierDetail(this.id)
      if (data.data.code === this.$code) {
        this.detailModalForm = data.data.data
      }
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.el-card__header {
  border-bottom: 1px solid #dcdfe6;
}
/deep/.el-card__body {
  padding: 24px 32px;
}
/deep/.el-form-item {
  margin-bottom: 0;
}
/deep/.el-form-item + .el-form-item {
  margin-top: 24px;
}
/deep/.el-form-item__label {
  line-height: 1;
}
/deep/.el-form-item__content {
  line-height: 1;
}
</style>
